export class FieldChangeResult {
    constructor(type, data) {
        this._type = FieldChangeResultType.Unknown;
        this._data = "";
        this._type = type;
        this._data = data;
    }
    get Type() {
        return this._type;
    }
    set Type(value) {
        this._type = value;
    }
    get Data() {
        return this._data;
    }
    set Data(value) {
        this._data = value;
    }
}
export class ResponseResult {
    constructor(type, data) {
        this._type = null;
        this._data = "";
        this._type = type;
        this._data = data;
    }
    get Type() {
        return this._type;
    }
    set Type(value) {
        this._type = value;
    }
    get Data() {
        return this._data;
    }
    set Data(value) {
        this._data = value;
    }
}
export var FieldChangeResultType;
(function (FieldChangeResultType) {
    FieldChangeResultType[FieldChangeResultType["ResourceDoesNotExists"] = -6] = "ResourceDoesNotExists";
    FieldChangeResultType[FieldChangeResultType["UnknownError"] = -5] = "UnknownError";
    FieldChangeResultType[FieldChangeResultType["NoPermissions"] = -4] = "NoPermissions";
    FieldChangeResultType[FieldChangeResultType["WrongData"] = -3] = "WrongData";
    FieldChangeResultType[FieldChangeResultType["ControllerResponseTimeout"] = -2] = "ControllerResponseTimeout";
    FieldChangeResultType[FieldChangeResultType["Failed"] = -1] = "Failed";
    FieldChangeResultType[FieldChangeResultType["Unknown"] = 0] = "Unknown";
    FieldChangeResultType[FieldChangeResultType["Changed"] = 1] = "Changed";
})(FieldChangeResultType || (FieldChangeResultType = {}));
//# sourceMappingURL=FieldChangeResult.js.map